import script from './Script';
export default script;
